import { render } from "./CatalogOrder.vue?vue&type=template&id=ec12044a&scoped=true"
import script from "./CatalogOrder.vue?vue&type=script&lang=js"
export * from "./CatalogOrder.vue?vue&type=script&lang=js"

import "./CatalogOrder.vue?vue&type=style&index=0&id=ec12044a&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/ENSI/mi-stock-ensi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec12044a"]])

export default __exports__